import { render, staticRenderFns } from "./vue-wxlogin.vue?vue&type=template&id=3b51b4ff"
import script from "./vue-wxlogin.vue?vue&type=script&lang=js"
export * from "./vue-wxlogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports